import { toast as hotToast, ToastOptions, ToastPosition } from 'react-hot-toast';

type CustomToastOptions = ToastOptions & {
  id?: string;
  icon?: any;
  position?: ToastPosition;
};

const extractId = (message: any): string | undefined => {
  if (typeof message === 'string') {
    return message;
  }
  return undefined;
};

const customToast = (message: any, options?: CustomToastOptions) => {
  const id = options?.id || extractId(message);
  return hotToast(message, { id, ...options });
};

customToast.error = (message: any, options?: CustomToastOptions) => {
  const id = options?.id || extractId(message);
  return hotToast.error(message, { id, ...options });
};

customToast.success = (message: any, options?: CustomToastOptions) => {
  const id = options?.id || extractId(message);
  return hotToast.success(message, { id, ...options });
};

customToast.loading = (message: any, options?: CustomToastOptions) => {
  const id = options?.id || extractId(message);
  return hotToast.loading(message, { id, ...options });
};

customToast.dismiss = hotToast.dismiss;
customToast.remove = hotToast.remove;
customToast.promise = hotToast.promise;
customToast.custom = hotToast.custom;

// Preserve the original AppAlert object format for backwards compatibility
// with any remaining calls if they exist, although we replaced imports.
export const AppAlert = {
  error(message: string, id?: string) {
    customToast.error(message, { id });
  },
  warning(message: string, id?: string) {
    customToast(message, { icon: '⚠️', id });
  },
  success(message: string, id?: string) {
    customToast.success(message, { id });
  },
  show(message: string, id?: string) {
    customToast(message, { id });
  },
};

export { customToast as toast };
export default customToast;
